import {show_error_message} from "../error_handling/error_handling";

export function persian_character_regex( str ) {
    var p = /^[\u0600-\u06FF\s]+$/;
    if (!str.match(p)) return false;
    return true;
}

export function persian_text_regex( str )
{
    var p = /^[\u0600-\u06FF\s\-_].{4,}$/;
    if (!str.match(p)) return false;
    return true;
}

export function select_regex( str ) {
    var p = /^[\u0600-\u06FF\s]|[\w\s]$/;
    if (!str.match(p)) return false;
    return true;
}
export function username_regex( str ) {
    var p = /^[a-zA-Z0-9][a-zA-Z0-9_]*[a-zA-Z0-9]$/;
    if (!str.match(p)) return false;
    return true;
}
export function email_regex( str ) {
    var p = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!str.match(p)) return false;
    return true;
}
export function password_regex( str ) {
    var p = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
    if (!str.match(p)) return false;
    return true;
}
export function phone_regex( str ) {
    var p = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{5,6}$/im;
    if (!str.match(p)) return false;
    return true;
}
export function postcode_regex( str ) {
    var p = /^[0-9]{10}$/im;
    if (!str.match(p)) return false;
    return true;
}
export function number_regex_5_length( str ) {
    var p = /^[0-9]{5}$/im;
    if (!str.match(p)) return false;
    return true;
}
export function number_regex( str ) {
    var p = /^[0-9]$/im;
    if (!str.match(p)) return false;
    return true;
}

export function nationalIdCheck( nationalIdCheck )
{
    if (nationalIdCheck === "" || nationalIdCheck === undefined) {
        return false;
    }else if (isNaN(parseInt(nationalIdCheck))) {
        return false;
    } else if ( nationalIdCheck.length < 10 || nationalIdCheck.length > 10 ) {
        return false;
    } else {
        let yy = 0;
        let yv = [];
        let joda = [];
        for (let i = 0; i < nationalIdCheck.length; i++) {
            joda[i] = nationalIdCheck[nationalIdCheck.length - i - 1];
        }
        joda = joda.reverse();
        for (let i = 0; i < nationalIdCheck.length - 1; i++) {
            yv[i] = parseInt(joda[i]) * (nationalIdCheck.length - i);
            yy += yv[i];
        }
        var x = yy % 11;
        if (x < 2) {
            if (x === parseInt(joda[nationalIdCheck.length - 1])) {
                yy = 0;
                return true;
            } else {
                yy = 0;
                return false;
            }
        } else {
            if ((11 - x) === parseInt(joda[nationalIdCheck.length - 1])) {
                yy = 0;
                return true;
            } else {
                yy = 0;
                return false;
            }
        }
        yy = 0;
        return false;
    }
}

export function validate_image_files( input, theSize ) {
    var file = input.files[0];
    var fileSize = ( file.size )/1024;
    var t = file.type.split('/').pop().toLowerCase();
    if (t != "jpeg" && t != "jpg" && t != "png") {
        input.value = '';
        return false;
    }
    if( theSize < fileSize ) {
        return false;
    }
    return true;
}

export function validateAndInsertMyImage( theInput, { url, action, nonce, theSize } )
{
    theInput.addEventListener('change', function () {
        if (theInput.value.trim() !== '') {
            if( validate_image_files( theInput, theSize ) ){
                jQuery.ajax( {
                    url : url,
                    method: "POST",
                    data:{
                        action : action,
                        nonce : nonce,
                    },
                    success : res => {
                        if( Number( res ) === 1 ){
                            theInput.parentElement.submit();
                        }
                    },
                    error : res => {
                        console.log( res );
                    }
                } );
            }else{
                show_the_error( 'تصاویر باید شامل پسوند های jpg،jpeg و png باشند و از سایز '+theSize+' کیلوبایت بزرگتر نباشند.' );
            }
        }
    });
}
export function loading() {
    return `<div class="sk-chase">
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                </div>`;
}

export function error_box( $title='', $msg = '', error_type = 'error', intervals )
{
    if( document.querySelector(".error_message_box")!==null && document.querySelector(".error_message_box")!==undefined ){
        let $error_box = document.querySelector(".error_message_box");
        if( ! $error_box.classList.contains("show") )
        {
            $error_box.classList.add( "show" );
            $error_box.classList.add( error_type );
            $error_box.querySelector( '.title h4' ).innerHTML = $title;
            $error_box.querySelector( '.body p' ).innerHTML = $msg;
        }
        let counter = 0;
        $error_box.querySelector('.loading_bar').style.width=0;
        let error_timer = setInterval(()=>{
            $error_box.querySelector('.loading_bar').style.width=counter+'%';
            counter = counter + 1 ;
            if( counter === 100 ) {
                $error_box.classList.remove('show');
                $error_box.classList.remove(error_type);
                $error_box.querySelector('.loading_bar').style.width=0;
                clearInterval( error_timer );
            }
        }, intervals );
    }
}

export function success_modal( $msg = '' )
{
    if( document.querySelector(".majixel_profile .error_modal.success")!==null && document.querySelector(".majixel_profile .error_modal.success")!==undefined ){
        let $modal_preview = document.querySelector(".majixel_profile .error_modal.success");
        let $overlay_layout = document.querySelector(".majixel_profile .majixel_profile_error_overlay_bg");
        let $modal_close = document.querySelector(".majixel_profile .error_modal.success .close span");
        if( ! $modal_preview.classList.contains("show") )
        {
            $overlay_layout.classList.add("show");
            $modal_preview.classList.add("show");
            $modal_preview.querySelector( '.content .body' ).innerHTML = $msg;
        }
        $modal_close.addEventListener('click', ()=>{
            if( $modal_preview.classList.contains("show") )
            {
                $overlay_layout.classList.remove("show");
                $modal_preview.classList.remove("show");
                $modal_preview.querySelector( '.content .body' ).innerHTML = '';
            }
        } );
    }
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function close_modal()
{
    document.querySelectorAll('.experts_modal_container .experts_modal .header .close_button').forEach( close_modal => {
        close_modal.addEventListener('click',ev=>{
            ev.preventDefault();
            close_modal.parentElement.parentElement.parentElement.classList.remove( 'show_modal' );
        });
    } );
}

export function show_the_error( $msg = '' )
{
    console.log( $msg );
}